import React from 'react'
import WorkExperienceCard from './work-experience-card'
import formatDate from '../../../../../../utils/formatDate'

const JobSeekerWorkexperience = ({ data }) => {
  return (
    <div className="candidate-profile mb-3 border rounded border-primary">
      <div className="work-experience card h-100 p-3">
        <div className="w-100">
          <h6 className="designation">{data["role"]}</h6>
          <p className="company-location">
            {data["company"]} - {data["city"]},{" "}
            {data["country"]}
          </p>
          {data["start_date"] !== null ? <p className="tenure">
            {formatDate(data["start_date"])} To{" "}
            {data["status"] === "Currently Working"
              ? data["status"]
              : formatDate(data["end_date"])}
          </p> : <p className="mb-0">Work experience tenure not found</p>}
          <p className="description">{data["description"]}</p>

          {data?.projects?.length > 0 && <h5 className="mb-2">Projects</h5>}
          {data?.projects?.length > 0 && data?.projects.map((project, projIndex) => (
            <WorkExperienceCard
              key={project.id}
              data={project}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default JobSeekerWorkexperience